<template>
  <div class="md-chip" :class="[themeClass, classes]" tabindex="0">
    <div class="md-chip-container" @click="(!disabled && mdEditable && $emit('edit')) || (multiple && $emit('select'))">
      <slot></slot>
    </div>

    <md-button
      class="md-icon-button md-dense md-delete"
      v-if="mdDeletable"
      @click="!disabled && $emit('delete', $event)"
      @keyup.native.delete="!disabled && $emit('delete')"
      tabindex="-1"
      :aria-label="cancelLabel"
    >
      <md-icon class="md-icon-delete" :mdSvg="mdiCloseCircle" />
    </md-button>
  </div>
</template>

<style lang="scss" src="./mdChip.theme"></style>
<style lang="scss" src="./mdChip.scss"></style>

<script>
import theme from '../../core/theme/mixins';
import { mdiCloseCircle } from '@mdi/js';

export default {
  name: 'md-chip',
  props: {
    disabled: Boolean,
    mdDeletable: Boolean,
    mdEditable: Boolean,
    cancelLabel: String,
    multiple: Boolean,
  },
  data: () => ({
    mdiCloseCircle,
  }),
  mixins: [theme],
  computed: {
    classes() {
      return {
        'md-deletable': this.mdDeletable,
        'md-disabled': this.disabled,
        'md-editable': this.mdEditable,
      };
    },
  },
};
</script>
